import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionComponent } from './subscription.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubscriptionStepOneComponent } from './components/subscription-step-one/subscription-step-one.component';
import { SubscriptionStepTwoComponent } from './components/subscription-step-two/subscription-step-two.component';
import { SubscriptionStepThreeComponent } from './components/subscription-step-three/subscription-step-three.component';

const subscriptionRoutes: Routes = [
  { path: '', component: SubscriptionComponent },
  { path: 'edit/:id', component: SubscriptionComponent },
];

@NgModule({
  declarations: [
    SubscriptionComponent,
    SubscriptionStepOneComponent,
    SubscriptionStepTwoComponent,
    SubscriptionStepThreeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(subscriptionRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})
export class SubscriptionModule { }
